import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { thankYouContent } from '../../common/json/thank-you-page-content'
import { GtmImplementation } from '../../common/api/services/gtmImplementation'
import { HeaderComponent } from '../../common/component/header/header.component';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.css'],
    imports: [HeaderComponent]
})
export class ThankYouComponent implements OnInit {
  isExisitngUser: any
  selectedLanguage: any
  thankYouContentPage: any

  constructor (
    public gtmImplementation: GtmImplementation,
    private router: Router
  ) {}

  ngOnInit (): void {
    sessionStorage.setItem('previousURL', 'thankyou')
    this.gtmImplementation.pageView('thank_you', 'signed_in_user', 'user_registration')
    this.isExisitngUser = localStorage.getItem('isExistingUser') ? localStorage.getItem('isExistingUser') : 'false'
    this.getContent()
  }

  // Based on the language it will show the static content
  getContent (): any {
    const sfResponse: any = localStorage.getItem('sfResponse')
    const officeDetails: any = JSON.parse(sfResponse)
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    if (this.selectedLanguage === 'EN') {
      this.thankYouContentPage = thankYouContent[this.selectedLanguage]
    } else {
      this.thankYouContentPage = thankYouContent[officeDetails?.wir_country_code + '_' + this.selectedLanguage]
    }
  }

  doneButton (): void {
    this.gtmImplementation.trackEvents('registration_completed', 'done_button', 'done', 'thank_you', 'signed_in_user', 'na')
    this.router.navigateByUrl('/landing')
  }

  openGooglePlayApp (): void {
    this.gtmImplementation.trackEvents('wir_app_download_click', 'get_it_on_google_play', 'android', 'thank_you', 'signed_in_user', 'app_download')
    window.open('https://play.google.com/store/apps/details?id=com.idp.study.abroad&hl=en_IN&gl=US', '_blank')
  }

  openAppleAppStore (): void {
    this.gtmImplementation.trackEvents('wir_app_download_click', 'download_on_the_app_store', 'ios', 'thank_you', 'signed_in_user', 'app_download')
    window.open('https://apps.apple.com/in/app/idp-study-abroad/id1466609835', '_blank')
  }
}
